<template>
  <div>
    <portal to="nav-bar">
      <nav-back-to-list />
    </portal>
    <request :method="request.method" :params="request.params" #default="{ loading, error }" v-model="response">
      <indeterminate-Line v-if="loading" class="mh2-l"/>
      <div v-else-if="error" class="ma3">Ошибка: {{ error }}</div>
      <div v-else>
        <cross-entities-links entityCode='claim' :entityId="id"/>
        <div class="entity-card">
          <div class="flex flex-row justify-between pa3 pa4-l">
            <div>
              <div class="flex flex-row items-center">
                <h1 class="db f3 f3-l ttu ma0 pa0 fw5">Заявка</h1>
                <span v-if="hightPriority" class="pl2 red f5">
                  <font-awesome-icon icon="fire-alt" />
                </span>
              </div>
              <span class="db mt2">{{ claim.id }}</span>
            </div>
            <div>
              <span class="entity-status">
                {{ claim.state }}
              </span>
            </div>
          </div>
          <entity-menu :items="menu" v-model="menuSelected"/>
          <keep-alive>
            <component :is="menu[menuSelected].component" :claim='claim' class="bg-white"/>
          </keep-alive>
        </div>
      </div>
    </request>
  </div>
</template>

<script>
import NavBackToList from '@/components/common/NavBackToList.vue'
import Request from '@/components/Request.vue'
import IndeterminateLine from '@/components/ui/progress/IndeterminateLine.vue'
import CrossEntitiesLinks from '@/components/common/CrossEntitiesLinks.vue'
import EntityMenu from '@/components/common/EntityMenu.vue'
import CardDetails from '@/components/claims/CardDetails.vue'
import CardProducts from '@/components/claims/CardProducts.vue'
import CardJournal from '@/components/claims/CardJournal.vue'
import CardComments from '@/components/claims/CardComments.vue'

export default {
  components: {
    NavBackToList,
    Request,
    IndeterminateLine,
    CrossEntitiesLinks,
    EntityMenu,
    CardDetails,
    CardProducts,
    CardJournal,
    CardComments
  },
  props: ['id'],
  data () {
    return {
      request: {
        method: 'getClaims',
        params: {
          claimId: this.id
        }
      },
      response: null,
      menu: [{
        index: 0, name: 'Условия', component: 'CardDetails'
      }, {
        index: 1, name: 'Товары', component: 'CardProducts'
      }, {
        index: 2, name: 'Журнал', component: 'CardJournal'
      }, {
        index: 3, name: 'Комментарии', component: 'CardComments'
      }],
      menuSelected: 0
    }
  },
  computed: {
    hightPriority () {
      return this.claim ? this.claim.priority_id === 1 : false
    },
    claim () {
      return this.response.claims
        ? this.response.claims[0]
        : null
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
